// extracted by mini-css-extract-plugin
export default {"main":"BulkFundamentals_main__+TWJe"};